import {ErrorMessage, Field, Form, Formik} from 'formik';
import {useTranslations} from 'next-intl';
import {Button, Input, Textarea} from '../design-system';

const encode = (data) => {
  return Object.keys(data)
    .map(
      (key) =>
        encodeURIComponent(key.replace('_', '.')) +
        '=' +
        encodeURIComponent(data[key]),
    )
    .join('&');
};

const ProductsForm = (props) => {
  const t = useTranslations('google-forms');
  return (
    <Formik
      initialValues={{
        // Nome
        entry_2005620554: '',
        // Cognome
        entry_1045781291: '',
        // Azienda
        entry_1065046570: '',
        // Tipologia prodotto
        entry_1740444196: '',
        // Regione di provenienza
        entry_2018567088: '',
        // Volume di produzione
        entry_1137374744: '',
        // Telefono
        entry_1166974658: '',
        // E-mail
        entry_839337160: '',
        // Canali attuali
        entry_80223449: '',
        // Obiettivi
        entry_1086093903: '',
        // Richiesta
        entry_280595519: '',
      }}
      initialStatus={{error: '', success: ''}}
      onSubmit={async (values, actions) => {
        try {
          const response = await fetch(
            'https://docs.google.com/forms/d/e/1FAIpQLSevdTu2t7eci-Zvph_aV_Pt8wq2sjCcyEAUPG1Mo2R-3Hp1DQ/formResponse',
            {
              headers: {'Content-Type': 'application/x-www-form-urlencoded'},
              method: 'POST',
              mode: 'no-cors',
              body: encode(values),
            },
          );
          actions.setStatus({success: t('common.success')});
        } catch (err) {
          actions.setStatus({
            error: t('common.error'),
          });
        } finally {
          actions.setSubmitting(false);
        }
      }}
      render={({values, status, handleChange, isSubmitting}) => {
        return (
          <Form>
            <div className="grid grid-cols-1 md:grid-cols-6 gap-4 mb-4">
              <div className="md:col-span-2">
                <Field
                  as={Input}
                  label={t('ProductsForm.label.name')}
                  placeholder={t('ProductsForm.placeholder.name')}
                  disabled={isSubmitting}
                  value={values.entry_2005620554}
                  onChange={handleChange}
                  onBlur={() => {
                    return;
                  }}
                  name="entry_2005620554"
                  id="entry_2005620554"
                  required
                />
                <ErrorMessage
                  name="entry_2005620554"
                  className="text-error-dark"
                />
              </div>
              <div className="md:col-span-2">
                <Field
                  as={Input}
                  label={t('ProductsForm.label.lastname')}
                  placeholder={t('ProductsForm.placeholder.lastname')}
                  disabled={isSubmitting}
                  value={values.entry_1045781291}
                  onChange={handleChange}
                  onBlur={() => {
                    return;
                  }}
                  name="entry_1045781291"
                  id="entry_1045781291"
                  required
                />
                <ErrorMessage
                  name="entry_1045781291"
                  className="text-error-dark"
                />
              </div>
              <div className="md:col-span-2">
                <Field
                  as={Input}
                  label={t('ProductsForm.label.company')}
                  placeholder={t('ProductsForm.placeholder.company')}
                  disabled={isSubmitting}
                  value={values.entry_1065046570}
                  onChange={handleChange}
                  onBlur={() => {
                    return;
                  }}
                  name="entry_1065046570"
                  id="entry_1065046570"
                  required
                />
                <ErrorMessage
                  name="entry_1065046570"
                  className="text-error-dark"
                />
              </div>
              <div className="md:col-span-2">
                <Field
                  as={Input}
                  label={t('ProductsForm.label.product')}
                  placeholder={t('ProductsForm.placeholder.product')}
                  disabled={isSubmitting}
                  value={values.entry_1740444196}
                  onChange={handleChange}
                  onBlur={() => {
                    return;
                  }}
                  name="entry_1740444196"
                  id="entry_1740444196"
                  required
                />
                <ErrorMessage
                  name="entry_1740444196"
                  className="text-error-dark"
                />
              </div>
              <div className="md:col-span-2">
                <Field
                  as={Input}
                  label={t('ProductsForm.label.region')}
                  placeholder={t('ProductsForm.placeholder.region')}
                  disabled={isSubmitting}
                  value={values.entry_2018567088}
                  onChange={handleChange}
                  onBlur={() => {
                    return;
                  }}
                  name="entry_2018567088"
                  id="entry_2018567088"
                  required
                />
                <ErrorMessage
                  name="entry_2018567088"
                  className="text-error-dark"
                />
              </div>
              <div className="md:col-span-2">
                <Field
                  as={Input}
                  label={t('ProductsForm.label.volume')}
                  placeholder={t('ProductsForm.placeholder.volume')}
                  disabled={isSubmitting}
                  value={values.entry_1137374744}
                  onChange={handleChange}
                  onBlur={() => {
                    return;
                  }}
                  name="entry_1137374744"
                  id="entry_1137374744"
                  required
                />
                <ErrorMessage
                  name="entry_1137374744"
                  className="text-error-dark"
                />
              </div>
              <div className="md:col-span-3">
                <Field
                  as={Input}
                  label={t('ProductsForm.label.phone')}
                  placeholder={t('ProductsForm.placeholder.phone')}
                  disabled={isSubmitting}
                  value={values.entry_1166974658}
                  onChange={handleChange}
                  onBlur={() => {
                    return;
                  }}
                  name="entry_1166974658"
                  id="entry_1166974658"
                  required
                />
                <ErrorMessage
                  name="entry_1166974658"
                  className="text-error-dark"
                />
              </div>
              <div className="md:col-span-3">
                <Field
                  as={Input}
                  label={t('ProductsForm.label.email')}
                  placeholder={t('ProductsForm.placeholder.email')}
                  disabled={isSubmitting}
                  value={values.entry_839337160}
                  onChange={handleChange}
                  onBlur={() => {
                    return;
                  }}
                  name="entry_839337160"
                  id="entry_839337160"
                  required
                />
                <ErrorMessage
                  name="entry_839337160"
                  className="text-error-dark"
                />
              </div>
              <div className="md:col-span-6">
                <Field
                  as={Textarea}
                  label={t('ProductsForm.label.actual-channel')}
                  placeholder={t('ProductsForm.placeholder.actual-channel')}
                  disabled={isSubmitting}
                  value={values.entry_80223449}
                  onChange={handleChange}
                  onBlur={() => {
                    return;
                  }}
                  name="entry_80223449"
                  rows={4}
                  required
                />
                <ErrorMessage
                  name="entry_80223449"
                  className="text-error-dark"
                />
              </div>
              <div className="md:col-span-6">
                <Field
                  as={Textarea}
                  label={t('ProductsForm.label.goals')}
                  placeholder={t('ProductsForm.placeholder.goals')}
                  disabled={isSubmitting}
                  value={values.entry_1086093903}
                  onChange={handleChange}
                  onBlur={() => {
                    return;
                  }}
                  name="entry_1086093903"
                  rows={4}
                  required
                />
                <ErrorMessage
                  name="entry_1086093903"
                  className="text-error-dark"
                />
              </div>
              <div className="md:col-span-6">
                <Field
                  as={Textarea}
                  label={t('ProductsForm.label.your-request')}
                  placeholder={t('ProductsForm.placeholder.your-request')}
                  disabled={isSubmitting}
                  value={values.entry_280595519}
                  onChange={handleChange}
                  onBlur={() => {
                    return;
                  }}
                  name="entry_280595519"
                  rows={4}
                  required
                />
                <ErrorMessage
                  name="entry_280595519"
                  className="text-error-dark"
                />
              </div>
            </div>
            <div>
              {status && status.error && (
                <div className="md:w-1/2 mx-auto relative p-6 rounded-sm border bg-[#ff52521f] border-error-dark text-error-dark ">
                  {status.error}
                </div>
              )}
              {status && status.success && (
                <div className="md:w-5/12 mx-auto relative p-6 rounded-sm border bg-[#43d9a31f] border-success-dark text-success-dark text-center">
                  {status.success}
                </div>
              )}
            </div>
            {status && !status.success && (
              <div className="text-center">
                <Button
                  className="min-w-60 max-md:w-full text-xl"
                  type="submit"
                  size="lg"
                  loading={isSubmitting}
                  disabled={isSubmitting}
                >
                  {t('common.send')}
                </Button>
              </div>
            )}
          </Form>
        );
      }}
    />
  );
};

export default ProductsForm;
